import * as msal from '@azure/msal-browser'

export const msalConfig = {
  auth: {
    clientId: process.env.NEXT_PUBLIC_AZURE_AD_CLIENT_ID,
    redirectUri: '/',
    authority: process.env.NEXT_PUBLIC_AZURE_AD_AUTHORITY,
    knownAuthorities: [process.env.NEXT_PUBLIC_KNOWN_AUTHORITIES],
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}

export const msalInstance = new msal.PublicClientApplication(msalConfig)

export const logout = () => {
  msalInstance.logoutRedirect()
  localStorage.clear()
  sessionStorage.clear()
  localStorage.setItem('logout-event', 'started')
  localStorage.removeItem('logout-event')
}
